<template>
    <div>
        <div class="row justify-content-center mt-4" v-if="cabinetFormVisible">
            <form>
                <div class="form-group">
                    <label class="text-left">Nom du cabinet</label>
                    <input type="text" class="form-control mb-2" v-model.trim="cabinetNom" @input="$v.cabinetNom.$touch" :class="{ 'is-invalid': $v.cabinetNom.$error }">
                    <div class="invalid-feedback" v-if="!$v.cabinetNom.required">Champ obligatoire</div>
                    <div class="invalid-feedback" v-if="!$v.cabinetNom.minLength">{{ $v.cabinetNom.$params.minLength.min }} caractères requis.</div>
                    <div class="invalid-feedback" v-if="!$v.cabinetNom.uniqueCabinetName">Ce cabinet existe déjà</div>
                </div>
                <div class="form-group">
                    <label class="text-left">Url du cabinet</label>
                    <input type="text" class="form-control mb-2" v-model.trim="cabinetUrl" @input="$v.cabinetUrl.$touch" :class="{ 'is-invalid': $v.cabinetUrl.$error }" autocapitalize="none" autocorrect="off" spellcheck="false" inputmode="url">
                    <div class="invalid-feedback" v-if="!$v.cabinetUrl.required">
                        Champ obligatoire
                    </div>
                    <div class="invalid-feedback" v-if="!$v.cabinetUrl.url">
                        Url invalide
                    </div>
                </div>
                <div class="text-center">
                    <button type="button" class="btn btn-success btn-sm" @click="addCabinet()" :disabled="$v.$invalid" v-if="!isEditMode">Ajouter</button>
                    <button type="button" class="btn btn-success btn-sm" @click="saveCabinet()" :disabled="$v.$invalid" v-else>Editer</button>
                </div>
            </form>
        </div>
        <div class="row mt-5" v-if="cabinetsVisible">
            <div class="col-12">
                <button class="btn btn-outline-success btn-sm float-right mb-2" @click="showCabinetForm()">
                    <i class="fas fa-plus"></i>
                </button>
                <table class="table table-sm table-bordered">
                    <thead class="thead-dark">
                        <tr>
                            <th class="w-50 text-center">Cabinet</th>
                            <th class="w-25 text-center">Url</th>
                            <th class="w-25 text-center">Connecté</th>
                            <th class="w-25 text-center">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(cabinet, index) in $store.state.cabinets" :key="index">
                            <td class="text-center">{{ cabinet.nom }}</td>
                            <td class="text-center">
                                <i class="fas fa-info-circle" data-toggle="tooltip" data-placement="top" :title="cabinet.url">
                                </i>
                            </td>
                            <td class="text-center">
                                <i class="fas fa-check text-success" v-if="isLoggedIn(cabinet)"></i>
                                <i class="fas fa-times text-danger" v-if="!isLoggedIn(cabinet)"></i>
                            </td>
                            <td class="text-center">
                                <button type="button" class="btn btn-outline-info btn-sm" @click="editCabinet(cabinet)"  style="font-size: 0.6em">
                                    <i class="fas fa-pen"></i>
                                </button>
                                <button type="button" class="btn btn-outline-danger btn-sm" @click="deleteCabinet(cabinet)" style="font-size: 0.6em">
                                    <i class="fas fa-times"></i>
                                </button>
                            </td>
                        </tr>
                        <tr v-if="$store.state.cabinets.length == 0">
                            <td colspan="4" class="text-center">Aucun cabinet</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import { Component, Watch, Vue, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import LysiasApiMixin from '../mixins/LysiasApiMixin'
import { required, minLength, url } from 'vuelidate/lib/validators'
import Vuelidate from 'vuelidate'
import SettingsMixin from '../mixins/SettingsMixin'
import { Cabinet } from '@/interfaces/interfaces'

Vue.use(Vuelidate as any)

Component.registerHooks(['validations'])


@Component
export default class Cabinets extends mixins(LysiasApiMixin, SettingsMixin)
{
    cabinetId: number|null = null;
    cabinetNom = "";
    cabinetUrl = "";
    isEditMode = false;
    @Prop() readonly cabinetsVisible = false;
    @Prop() readonly cabinetFormVisible = false;

    deleteCabinet(cabinet: Cabinet)
    {
        this.$store.commit('deleteCabinet', cabinet);

        this.saveCabinets();
    }

    editCabinet(cabinet: Cabinet)
    {
        this.isEditMode = true;
        this.$store.commit('setLoginFormVisible', false);
        this.$store.commit('setCabinetFormVisible', true);
        this.$store.commit('setCabinetsVisible', false);
        this.cabinetId = cabinet.id;
        this.cabinetNom = cabinet.nom;
        this.cabinetUrl = cabinet.url;
    }

    showCabinetForm()
    {
        this.$store.commit('setLoginFormVisible', false);
        this.$store.commit('setCabinetFormVisible', true);
        this.$store.commit('setCabinetsVisible', false);
        this.cabinetNom = "";
        this.cabinetUrl = "";
    }

    addCabinet()
    {
        this.isEditMode = false;
        this.$store.commit('addCabinet', new Cabinet(this.cabinetNom, this.cabinetUrl));

        this.saveCabinets();
        this.$emit('show-cabinets', true);
    }

    saveCabinet()
    {
        debugger
        const cabinet = new Cabinet(this.cabinetNom, this.cabinetUrl);
        cabinet.id = this.cabinetId;
        this.$store.commit('updateCabinet', { cabinet });

        this.saveCabinets();
        this.$emit('show-cabinets', true);
    }

    isLoggedIn(cabinet: Cabinet)
    {
        return cabinet && cabinet.credentials.username != "" && cabinet.credentials.password != "";
    }

    validations()
    {
        const that = this;
        return {
            cabinetNom:
            {
                required,
                minLength: minLength(3),
                uniqueCabinetName(name: string)
                {
                    return that.$store.state.cabinets.find((c: Cabinet) => c.nom == name) == undefined || that.isEditMode;
                },
            },
            cabinetUrl:
            {
                required,
                url,
            }
        };
    }
}
</script>
